'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const GoLiveIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="GoLiveIcon">
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        id="Light-Mode-Flash-On--Streamline-Ultimate"
        height="24"
        width="24"
      >
        <desc>Light Mode Flash On Streamline Icon: https://streamlinehq.com</desc>
        <path
          d="M0.5 12a11.5 11.5 0 1 0 23 0 11.5 11.5 0 1 0 -23 0Z"
          fill="none"
          stroke="rgba(61, 81, 123, 0.5)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M11.372 3.939a0.928 0.928 0 0 1 0.738 -0.439h3.54c0.275 0 0.382 0.191 0.237 0.425L12.426 9.5h4.163c0.275 0 0.348 0.166 0.163 0.369l-9.108 9.963c-0.186 0.2 -0.252 0.161 -0.149 -0.094l2.952 -7.238H7.222a0.273 0.273 0 0 1 -0.262 -0.439Z"
          fill="none"
          stroke="rgba(61, 81, 123, 0.5)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
      </svg>
    </SvgIcon>
  )
}

GoLiveIcon.propTypes = {
  sx: PropTypes.object
}
